/* src/app/private/components/dialing-group/call-campaign-details/call-campaign-details.component.scss */
.table-container ::ng-deep .p-datatable .p-datatable-header {
  border-radius: 12px 12px 0 0;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th {
  font-weight: 600;
  font-size: 0.875rem;
  padding: 1rem 0.75rem;
  text-align: center;
  border: none;
  white-space: nowrap;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:first-child {
  border-radius: 12px 0 0 0;
  min-width: 60px;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:last-child {
  border-radius: 0 12px 0 0;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:nth-child(1) {
  min-width: 60px;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:nth-child(2) {
  min-width: 150px;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:nth-child(3) {
  min-width: 130px;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:nth-child(4) {
  min-width: 200px;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:nth-child(5) {
  min-width: 130px;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:nth-child(6) {
  min-width: 180px;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:nth-child(7) {
  min-width: 120px;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:nth-child(8) {
  min-width: 150px;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:nth-child(9) {
  min-width: 150px;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:nth-child(10) {
  min-width: 100px;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:nth-child(11) {
  min-width: 80px;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:nth-child(12) {
  min-width: 120px;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:nth-child(13) {
  min-width: 100px;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:nth-child(14) {
  min-width: 120px;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:nth-child(15) {
  min-width: 150px;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:nth-child(16) {
  min-width: 140px;
}
.table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th:nth-child(17) {
  min-width: 120px;
}
.table-container ::ng-deep .p-datatable .p-datatable-tbody > tr {
  transition: all 0.2s ease;
}
.table-container ::ng-deep .p-datatable .p-datatable-tbody > tr:hover {
  transform: translateY(-1px);
}
.table-container ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
  padding: 0.875rem 0.75rem;
  vertical-align: middle;
  font-size: 0.875rem;
  text-align: center;
}
.table-container ::ng-deep .p-datatable .p-datatable-tbody > tr > td:first-child {
  font-weight: 600;
}
.table-container ::ng-deep .p-datatable .p-datatable-tbody > tr > td:nth-child(8),
.table-container ::ng-deep .p-datatable .p-datatable-tbody > tr > td:nth-child(15) {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.table-container ::ng-deep .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view {
  overflow-x: auto;
}
.table-container ::ng-deep .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view::-webkit-scrollbar {
  height: 8px;
}
.table-container ::ng-deep .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view::-webkit-scrollbar-track {
  border-radius: 4px;
}
.table-container ::ng-deep .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.table-container ::ng-deep .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
@media (max-width: 1400px) {
  .table-container ::ng-deep .p-datatable-thead > tr > th {
    padding: 0.75rem 0.5rem;
    font-size: 0.8rem;
  }
  .table-container ::ng-deep .p-datatable-tbody > tr > td {
    padding: 0.75rem 0.5rem;
    font-size: 0.8rem;
  }
}
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
}
.status-badge::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: currentColor;
}
/*# sourceMappingURL=call-campaign-details.component.css.map */
